import { createGlobalStyle, css } from 'styled-components';
var isSvg = function isSvg(value) {
  return value.indexOf('<svg') > -1;
};
var isValidCssVariable = function isValidCssVariable(tokenValue) {
  if (typeof tokenValue !== 'string') return false;
  if (isSvg(tokenValue)) return false;
  return true;
};
export default createGlobalStyle(["html,body,legend{margin:0;padding:0;}main{display:block;}.csl-dialog-open{overflow:hidden;}.csl-sr-only{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;}", " ", ""], function (_ref) {
  var $fonts = _ref.$fonts,
    $ssr = _ref.$ssr;
  return $ssr && $fonts;
}, function (_ref2) {
  var _$tokens$colorSchemes;
  var _ref2$$colorScheme = _ref2.$colorScheme,
    $colorScheme = _ref2$$colorScheme === void 0 ? '' : _ref2$$colorScheme,
    $enableCssVariables = _ref2.$enableCssVariables,
    $tokens = _ref2.$tokens;
  return $enableCssVariables && css([":root{", "}", " ", " ", ""], Object.keys($tokens).map(function (key) {
    return isValidCssVariable($tokens[key]) ? "--".concat(key.replace(/_/g, '-'), ": ").concat($tokens[key], ";") : '';
  }).join('\n'), $colorScheme === 'auto' && css(["@media (prefers-color-scheme:dark){"]), ['dark', 'auto'].includes($colorScheme) && css([":root{", "}"], Object.keys(($tokens === null || $tokens === void 0 ? void 0 : (_$tokens$colorSchemes = $tokens.colorSchemes) === null || _$tokens$colorSchemes === void 0 ? void 0 : _$tokens$colorSchemes.dark) || {}).map(function (key) {
    var _$tokens$colorSchemes2, _$tokens$colorSchemes3;
    return isValidCssVariable($tokens === null || $tokens === void 0 ? void 0 : (_$tokens$colorSchemes2 = $tokens.colorSchemes) === null || _$tokens$colorSchemes2 === void 0 ? void 0 : _$tokens$colorSchemes2.dark[key]) ? "--".concat(key.replace(/_/g, '-'), ": ").concat($tokens === null || $tokens === void 0 ? void 0 : (_$tokens$colorSchemes3 = $tokens.colorSchemes) === null || _$tokens$colorSchemes3 === void 0 ? void 0 : _$tokens$colorSchemes3.dark[key], ";") : '';
  }).join('\n')), $colorScheme === 'auto' && css(["}"]));
});